<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						公主競技場
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title mb-4" style="cursor: pointer" data-toggle="collapse" href="#rank_reward" role="button" aria-expanded="false" aria-controls="rank_reward">
					公主競技場最高階級獎勵
					<div class="arrow"><span></span><span></span></div>
				</h3>
				<div class="item-content collapse show multi-collapse" id="rank_reward">
					<table class="table table-bordered table-hover">
						<thead>
							<th>階級</th>
							<th>階級獎勵</th>
							<th>階級總和</th>
						</thead>
						<tr v-for="item in rank_reward">
							<th width="25%">
								{{item.rank_from}}→{{item.rank_to}}
							</th>
							<td>
								<img width="50" class="aligncenter m-mxauto" :src="'/static/images/item/icon_item_'+ item['reward_id_1'] +'.png'"> x {{item.reward_num_1}}
							</td>
							<td>
								<img class="m-mxauto" width="50" src="/static/images/item/icon_item_91002.png">
								x
								{{((item.rank_to - item.rank_from)+ 1 ) * item.reward_num_1}}
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="item-box my-3">
				<h3 class="item-title mb-4" style="cursor: pointer" data-toggle="collapse" href="#daily_reward" role="button" aria-expanded="false" aria-controls="daily_reward">
					公主競技場每日獎勵
					<div class="arrow"><span></span><span></span></div>
				</h3>
				<div class="item-content collapse show multi-collapse" id="daily_reward">
					<table class="table table-bordered table-hover">
						<thead>
							<th>階級</th>
							<th colspan="4">獎勵</th>
						</thead>
						<tr v-for="item in daily_reward">
							<th width="25%">
								{{item.rank_from}}→{{item.rank_to}}
							</th>
							<td v-for="n in 4">
								<template v-if="item['reward_type_' + n] != 0">
									<img width="50" class="aligncenter" :src="'/static/images/item/icon_item_'+ item['reward_id_'+n] +'.png'"> x {{item["reward_num_" + n]}}
								</template>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="item-box my-3">
				<h3 class="item-title mb-4" style="cursor: pointer" data-toggle="collapse" href="#defence_reward" role="button" aria-expanded="false" aria-controls="defence_reward">
					防守獎勵
					<div class="arrow"><span></span><span></span></div>
				</h3>
				<div class="item-content collapse show multi-collapse" id="defence_reward">
					<table class="table table-bordered table-hover">
						<thead>
							<th>每日領取</th>
							<th>獎勵</th>
						</thead>
						<tr v-for="item in defence_reward">
							<th width="25%">
								最多領取 {{item.limit_count}} 次
							</th>
							<td v-for="n in 1">
								<template v-if="item['reward_type_' + n] != 0">
									<img width="50" class="aligncenter" :src="'/static/images/item/icon_item_'+ item['reward_id_'+n] +'.png'"> x {{item["reward_num_" + n]}}
								</template>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="item-box">
				<h3 class="item-title mb-4" style="cursor: pointer" data-toggle="collapse" href="#time_reward" role="button" aria-expanded="false" aria-controls="time_reward">
					每小時獎勵 (不確定)
					<div class="arrow"><span></span><span></span></div>
				</h3>
				<div class="item-content collapse show multi-collapse" id="time_reward">
					<table class="table table-bordered table-hover">
						<thead>
							<th>階級/1小時</th>
							<th>獎勵</th>
						</thead>
						<tbody>
							<tr v-for="item in time_reward">
								<th width="25%">
									{{item.rank_from}}→{{item.rank_to}}
								</th>
								<td v-for="n in 1">
									<template v-if="item['reward_type_' + n] != 0">
										<img width="50" class="aligncenter" :src="'/static/images/item/icon_item_'+ item['reward_id_'+n] +'.png'"> x {{item["reward_num_" + n]}}
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import grand_arena_daily_rank_reward from '../../assets/edata/arena_daily_rank_reward.txt'
import grand_arena_defence_reward from '../../assets/edata/arena_defence_reward.txt'
import grand_arena_max_rank_reward from '../../assets/edata/arena_max_rank_reward.txt'
import grand_arena_time_rank_reward from '../../assets/edata/arena_time_rank_reward.txt'
export default {
	name: 'GrandArena',
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '公主競技場',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	data() {
		return {
			daily_reward:{},
			defence_reward:{},
			rank_reward:{},
			time_reward:{}
		}
	},
	created: function() {
		var self = this;
		var grandArenaDailyRankReward = JSON.parse(self.atou(grand_arena_daily_rank_reward));
		var grandArenaDefenceReward = JSON.parse(self.atou(grand_arena_defence_reward));
		var grandArenaMaxRankReward = JSON.parse(self.atou(grand_arena_max_rank_reward));
		var grandArenaTimeRankReward = JSON.parse(self.atou(grand_arena_time_rank_reward));
		this.daily_reward = grandArenaDailyRankReward;
		this.defence_reward = grandArenaDefenceReward;
		this.rank_reward = grandArenaMaxRankReward;
		this.time_reward = grandArenaTimeRankReward;
	},
	computed: {

	},
	mounted: function() {
		$(document).on('click', "h3.item-title", function() {
			$(this).find(".arrow").toggleClass('active');
		});
	}
}

</script>
<style scoped>


</style>
